
import React, { useEffect, useState } from "react";
import classnames from "classnames";
// reactstrap components
import {
    // Badge,
    Card,
    CardHeader,
    Table,
    Container,
    Row,
    Button,
    Col,
    UncontrolledTooltip,
    Modal,
    CardBody,
    Form,
    FormGroup,
    InputGroup,
    InputGroupAddon,
    Input,
    InputGroupText,
    ModalBody,
    ModalHeader,
    UncontrolledAlert,
    Pagination,
    PaginationItem,
    PaginationLink
} from "reactstrap";

import { useNavigate } from 'react-router-dom';
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import { getAllUsers, createUsers, updateUser, deleteUser } from "api/usersApiCall";
import Swal from "sweetalert2";
import { getUserLogo } from "api/authApiCall";
import { useTranslation } from '../../../i18n/context';

function Users() {
    const [allUsers, setAllUsers] = useState([]);
    const [allUsersError, setAllUsersError] = useState({});
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [formModal, setFormModal] = useState(false);
    const [yourName, setYourName] = useState(false);
    const [emailAddress, setEmailAddress] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(false);
    const [tooltipIds, setTooltipIds] = useState([]);
    const [selectedUser, setSelectedUser] = useState({});
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [logoPreview, setLogoPreview] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const logoUrl = getUserLogo();
    const [logo, setLogo] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [isDateFilterActive, setIsDateFilterActive] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (Array.isArray(allUsers)) {
            // Create unique IDs for each user row
            const ids = allUsers.map((_, index) => ({
                edit: `tooltipEdit${index}`,
                delete: `tooltipDelete${index}`,
            }));

            setTooltipIds(ids);
        } else {
            console.warn('allUsers is not an array:', allUsers);
        }
    }, [allUsers]);


    const fetchUsers = async () => {
        try {
            const response = await fetch('/api/users');
            // console.log(response);
            const data = await response.json();
            setAllUsers(data.map(user => ({ ...user, id: user.id || user._id })));
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const toggleModal = () => {
        setFormModal(!formModal);
    };

    const handleEditClick = (userData) => {
        setSelectedUser(userData);
        toggleModal();
    };



    useEffect(() => {
        let results = allUsers;

        if (searchTerm) {
            results = results.filter(user =>
                user.username.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Apply date filter if active
        if (isDateFilterActive && startDate && endDate) {
            const startDateTime = new Date(startDate).setHours(0, 0, 0, 0);
            const endDateTime = new Date(endDate).setHours(23, 59, 59, 999);

            results = results.filter(user => {
                const userDate = new Date(user.createdAt).getTime();
                return userDate >= startDateTime && userDate <= endDateTime;
            });
        }

        setFilteredUsers(results);
        setCurrentPage(1);
    }, [searchTerm, allUsers, startDate, endDate, isDateFilterActive]);

    const applyDateFilter = () => {
        setIsDateFilterActive(true);
    };

    // Add handler for clearing date filter
    const clearDateFilter = () => {
        setStartDate('');
        setEndDate('');
        setIsDateFilterActive(false);
    };

    const handleLogoChange = (e) => {
        // console.log(e.target.files[0])
        setLogo(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();

        // Append user data
        formData.append('username', selectedUser.username);
        formData.append('user_email', selectedUser.user_email);
        formData.append('user_phone', selectedUser.user_phone);


        if (logo) {
            // console.log(logo)
            formData.append('logo', logo, logo.name);
        }

        try {
            const userId = selectedUser._id;
            const [errorUserCall, successUserCall] = await updateUser(userId, formData);
            if (errorUserCall) {
                setErrorMessages([errorUserCall.message]);
                setShowErrorAlert(true);
            } else {
                setShowSuccessAlert(true);
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }
        } catch (error) {
            setErrorMessages([error.message]);
            setShowErrorAlert(true);
        }
    };

    //Delete
    const handleDeleteClick = (userId) => {
        Swal.fire({
            title: t('profile.sure'),
            text: t('profile.delete_text'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('profile.delete_confirm')
        }).then((result) => {
            if (result.isConfirmed) {
                deleteUser(userId)
                    .then(([error, successData]) => {
                        if (error) {
                            Swal.fire(
                                t('common.error'),
                                error.message || t('profile.delete_error_title'),
                                'error'
                            );
                        } else {
                            Swal.fire(
                                t('profile.delete_success_title'),
                                t('profile.delete_success_message'),
                                'success'
                            ).then(() => {
                                window.location.reload();
                            });
                        }
                    })
                    .catch(error => {
                        Swal.fire(
                            t('common.error'),
                            t('profile.delete_error_title'),
                            'error'
                        );
                    });
            }
        });
    };

    const handleAddUser = async () => {
        setIsLoading(true);
        const [errorUsersCall, successUserCall] = await createUsers({});
        // console.log(errorUsersCall, successUserCall);
        if (errorUsersCall || !successUserCall) {
            setAllUsersError(errorUsersCall);
        } else {
            setAllUsers(successUserCall);
        }
        setIsLoading(false);
    };

    const handleCall = async () => {
        const [errorUsersCall, successUserCall] = await getAllUsers({});
        // console.log(errorUsersCall, successUserCall)
        if (errorUsersCall || !successUserCall) {
            // show error messge
            setAllUsersError(errorUsersCall)

        } else {
            setAllUsers(successUserCall)

        }

    }
    useEffect(() => {
        handleCall();
    }, [])

    useEffect(() => {
        const timeOutError = setTimeout(() => {
            setAllUsersError({});
        }, 10000)
        return () => {
            clearTimeout(timeOutError);
        }
    }, [allUsersError])

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <SimpleHeader name={t('profile.profile')} />

            <Container className="mt--6" fluid>
                <Row>
                    <Col className="order-xl-1" xl="12">
                        <Card>
                            <CardHeader className="border-0">
                                <Row>
                                    <Col xs="6">
                                        <h3 className="mb-0">{t('profile.management')}</h3>
                                    </Col>
                                    <Col className="text-right" xs="6">
                                        {/* <Button
                                            className="btn-round btn-icon"
                                            color="primary"
                                            // href="#pablo"
                                            id="tooltip443412080"
                                            onClick={() => navigate('/admin/adduser')}
                                            size="sm"
                                        >
                                            <span className="btn-inner--icon mr-1">
                                                <i className="fas fa-user-edit" />
                                            </span>
                                            <span className="btn-inner--text">{t('profile.adduser')}</span>
                                        </Button>
                                        <UncontrolledTooltip delay={0} target="tooltip443412080">
                                            {t('profile.adduser')}
                                        </UncontrolledTooltip> */}
                                    </Col>
                                </Row>
                            </CardHeader>

                            <div className="px-3 py-2">
                                <Row>
                                    <Col md="6">
                                        <Input
                                            type="text"
                                            placeholder={t('invoice.searchUser')}
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </Col>
                                    <Col md="6">
                                        <Row>
                                            <Col md="4">
                                                <FormGroup>
                                                    <Input
                                                        type="date"
                                                        placeholder="Start Date"
                                                        value={startDate}
                                                        onChange={(e) => setStartDate(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="4">
                                                <FormGroup>
                                                    <Input
                                                        type="date"
                                                        placeholder="End Date"
                                                        value={endDate}
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="4">
                                                <FormGroup className="d-flex">
                                                    <Button
                                                        color="primary"
                                                        size="sm"
                                                        onClick={applyDateFilter}
                                                        className="mr-2"
                                                        disabled={!startDate || !endDate}
                                                    >
                                                        <i className="fas fa-filter mr-1"></i>
                                                        {t('invoice.filter')}
                                                    </Button>
                                                    {isDateFilterActive && (
                                                        <Button
                                                            color="secondary"
                                                            size="sm"
                                                            onClick={clearDateFilter}
                                                        >
                                                            <i className="fas fa-times mr-1"></i>
                                                            {t('invoice.clear')}
                                                        </Button>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            {allUsers && allUsers.length > 0 && (
                                <div className="table-responsive">

                                    <Table className="align-items-center table-flush">
                                        <thead className="thead-light">
                                            <tr>
                                                <th className="sort" data-sort="name" scope="col">
                                                    {t('profile.name')}
                                                </th>
                                                <th className="sort" data-sort="budget" scope="col">
                                                    {t('profile.phone')}
                                                </th>
                                                <th className="sort" data-sort="status" scope="col">
                                                    Email
                                                </th>
                                                <th className="sort" data-sort="status" scope="col">
                                                    Logo
                                                </th>
                                                <th>Action</th>


                                            </tr>
                                        </thead>

                                        <tbody className="list">
                                            {currentItems.map((userData, index) => (
                                                <tr key={index}>
                                                    <td>{userData?.username}</td>
                                                    <td>{userData?.user_phone}</td>
                                                    <td>{userData?.user_email}</td>
                                                    <td>
                                                        {userData?.logo ? (
                                                            <img
                                                                src={logoUrl}
                                                                alt={`${userData.username}'s logo`}
                                                                style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px' }}
                                                            />
                                                        ) : (
                                                            <div style={{ width: '40px', height: '40px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px' }}>
                                                                <i className="fas fa-image" style={{ color: '#aaa' }}></i>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="table-actions">
                                                        <a
                                                            className="table-action"
                                                            href="#pablo"
                                                            id={tooltipIds[index]?.edit}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleEditClick(userData);
                                                            }}
                                                        >
                                                            <i className="fas fa-user-edit" />
                                                        </a>
                                                        {tooltipIds[index] && (
                                                            <UncontrolledTooltip delay={0} target={tooltipIds[index].edit}>
                                                                {t('profile.edituser')}
                                                            </UncontrolledTooltip>
                                                        )}
                                                        <a
                                                            className="table-action table-action-delete"
                                                            // href="#pablo"
                                                            id={tooltipIds[index]?.delete}
                                                            onClick={() => {
                                                                // e.preventDefault();
                                                                handleDeleteClick(userData._id);
                                                            }}
                                                        >
                                                            <i className="fas fa-trash" />
                                                        </a>
                                                        {tooltipIds[index] && (
                                                            <UncontrolledTooltip delay={0} target={tooltipIds[index].delete}>
                                                                {t('profile.deleteuser')}
                                                            </UncontrolledTooltip>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}


                                        </tbody>

                                    </Table>

                                </div>
                            )}

                            <div className="card-footer py-4">
                                <Pagination>
                                    <PaginationItem disabled={currentPage === 1}>
                                        <PaginationLink previous onClick={() => paginate(currentPage - 1)} />
                                    </PaginationItem>
                                    {[...Array(Math.ceil(filteredUsers.length / itemsPerPage))].map((_, index) => (
                                        <PaginationItem key={index} active={index + 1 === currentPage}>
                                            <PaginationLink onClick={() => paginate(index + 1)}>
                                                {index + 1}
                                            </PaginationLink>
                                        </PaginationItem>
                                    ))}
                                    <PaginationItem disabled={currentPage === Math.ceil(filteredUsers.length / itemsPerPage)}>
                                        <PaginationLink next onClick={() => paginate(currentPage + 1)} />
                                    </PaginationItem>
                                </Pagination>
                            </div>

                        </Card>
                    </Col>
                </Row>
            </Container>

            <Modal className="modal-dialog-centered" size="sm" isOpen={formModal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>{t('profile.edituser')}</ModalHeader>
                <ModalBody>
                    <Card className="bg-secondary border-0 mb-0">
                        <CardBody className="px-lg-5">
                            <div className="text-center text-muted mb-4">
                                <small>{t('profile.edituser')}</small>
                            </div>
                            {showSuccessAlert && (
                                <UncontrolledAlert color="success">
                                    <span className="alert-text ml-1">
                                        <strong>{t('profile.success')}</strong>{t('profile.userupdated')}
                                    </span>
                                </UncontrolledAlert>
                            )}

                            {showErrorAlert && (
                                <UncontrolledAlert color="danger">
                                    <span className="alert-text ml-1">
                                        <strong>{t('common.error')}</strong> {t('profile.failed')}
                                    </span>
                                </UncontrolledAlert>
                            )}
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <InputGroup className={classnames("input-group-merge", { focused: yourName })}>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fas fa-user" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    placeholder={t('dashboard.name')}
                                                    type="text"
                                                    value={selectedUser.username || ''}
                                                    onChange={(e) => setSelectedUser({ ...selectedUser, username: e.target.value })}
                                                    required
                                                    onFocus={() => setYourName(true)}
                                                    onBlur={() => setYourName(false)}
                                                />
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup>
                                            <InputGroup className={classnames("input-group-merge", { focused: emailAddress })}>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fas fa-envelope" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    placeholder="Email"
                                                    type="email"
                                                    value={selectedUser.user_email || ''}
                                                    onChange={(e) => setSelectedUser({ ...selectedUser, user_email: e.target.value })}
                                                    required
                                                    onFocus={() => setEmailAddress(true)}
                                                    onBlur={() => setEmailAddress(false)}
                                                />
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup>
                                            <Input
                                                type="file"
                                                name="logo"
                                                id="logo"
                                                onChange={handleLogoChange}
                                                accept="image/*"
                                            />
                                            {logoPreview && (
                                                <img
                                                    src={logoPreview}
                                                    alt="Logo Preview"
                                                    style={{ width: '100px', height: '100px', objectFit: 'cover', marginTop: '10px' }}
                                                />
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <InputGroup className={classnames("input-group-merge", { focused: phoneNumber })}>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fas fa-phone" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    placeholder="Phone number"
                                                    type="text"
                                                    value={selectedUser.user_phone || ''}
                                                    onChange={(e) => setSelectedUser({ ...selectedUser, user_phone: e.target.value })}
                                                    required
                                                    onFocus={() => setPhoneNumber(true)}
                                                    onBlur={() => setPhoneNumber(false)}
                                                />
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    {/* <Col md="12">
                                        <FormGroup>
                                            <InputGroup className={classnames("input-group-merge", { focused: password })}>
                                                <Input
                                                    placeholder="Password"
                                                    type="password"
                                                    value={selectedUser.password || ''}
                                                    onChange={(e) => setSelectedUser({ ...selectedUser, password: e.target.value })}
                                                    onFocus={() => setPassword(true)}
                                                    onBlur={() => setPassword(false)}
                                                />
                                                <InputGroupAddon addonType="append">
                                                    <InputGroupText>
                                                        <i className="fas fa-eye" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col> */}
                                </Row>
                                <Button className="btn-icon" color="primary" type="submit">
                                    <span className="btn-inner--text">{t('profile.submit')}</span>
                                </Button>
                                <Button color="secondary" onClick={toggleModal}>{t('profile.cancel')}</Button>
                            </Form>
                        </CardBody>
                    </Card>
                </ModalBody>
            </Modal>


        </>
    );
}

export default Users;
